
import { useContext, useMemo } from "react";
import Valve from "../components/Valve";
import Transmitter4 from "../components/Transmitter4";
import Transmitter from "../components/Transmitter";
import "./CrudeExport.css";
import ControlValveControlPanel from "../components/ControlValveControlPanel";
import { useState, useEffect } from "react";
import { WellContext } from "../context/WellContext";
import { AlarmContext } from "../context/AlarmContext";
import LevelTransmitterIndicator from "../components/LevelTransmitterIndicator";
import { PumpContext } from "../context/PumpContext";
import Pump from "../components/Pump";
import PumpFaceplate from "../components/PumpFaceplate";

import { trackPageVisit } from "../competency/PageTracker";







 
      /* ✅ CONTROL VALVE PERCENTAGE OUTPUT Indicator */
                function ValveOutput({ value, x, y, r=0 }) {
                return (
                  <div
                    style={{
                      position: "absolute",
                      left: x,
                      top: y,
                      color: "white",
                      fontSize: "10px",
                      padding: "2px 6px",
                      borderRadius: "4px",
                      transform: `rotate(${r}deg)`,
                      transformOrigin: "center",
                      cursor: "pointer"
                    }}
                  >
                    {value.toFixed(1)}
                  </div>
                );
              }


function CrudeExport() {

      useEffect(() => {
  
    trackPageVisit("CrudeExport");
  
  }, []);

   const {  valves, toggleValve, transmitters} = useContext(WellContext);

  


  const DEFAULT_VALVES = {
  FCV_1601: { mode: "Manual", opening: 0, sp: "", pv: "" },
  FCV_1602: { mode: "Manual", opening: 0, sp: "", pv: "" },

};

const [valveData, setValveData] = useState(() => {
  const saved = localStorage.getItem("CrudeExport_valveData");

  if (!saved) return DEFAULT_VALVES;

  try {
    const parsed = JSON.parse(saved);

    // ✅ Merge saved + default (CRITICAL)
    return {
      FCV_1601: { ...DEFAULT_VALVES.FCV_1601, ...parsed.FCV_1601 },
      FCV_1602: { ...DEFAULT_VALVES.FCV_1602, ...parsed.FCV_1602 },
    };

  } catch {
    return DEFAULT_VALVES;
  }
});



/* ✅ Persist */
  useEffect(() => {
    localStorage.setItem("CrudeExport_valveData", JSON.stringify(valveData));
  }, [valveData]);

  /* ================= ✅ FIXED UPDATE FUNCTION ================= */
  const updateValveData = (tag, field, value) => {
  setValveData(prev => ({
    ...prev,
    [tag]: {
      ...(prev[tag] || DEFAULT_VALVES[tag]),
      [field]: field === "opening" ? Number(value) || 0 : value
    }
  }));
};

  /* ================= PANEL CONTROL ================= */
  const [openPanels, setOpenPanels] = useState([]);

  const openPanel = (tag) => {
    if (!openPanels.includes(tag)) {
      setOpenPanels(prev => [...prev, tag]);
    }
  };

  const closePanel = (tag) => {
    setOpenPanels(prev => prev.filter(p => p !== tag));
  };




  // ================= PUMP PANEL LOGIC =================

  const [openPumpPanels, setOpenPumpPanels] = useState([]);

const openPumpPanel = (tag) => {
  if (!openPumpPanels.includes(tag)) {
    setOpenPumpPanels(prev => [...prev, tag]);
  }
};

const closePumpPanel = (tag) => {
  setOpenPumpPanels(prev => prev.filter(p => p !== tag));
};




  // ================= INFLOW LOGIC from TEST, FIRST STAGE, SECOND AND THIRD STAGE SEPARATOR to OILY WATER TANK LEVEL TRANSMITTER =================
   






    

// ================= CONTEXT =================
const { pumpData } = useContext(PumpContext);

  const FIC_18002 = JSON.parse(
  localStorage.getItem("FIC_18002") || "false"
);

const TT_18003 = JSON.parse(
  localStorage.getItem("TT_18003") || "false"
);

  const PT_16001 = 0.45;

    const FIC_16001a = (valveData?.FCV_1601?.opening || 0)/1000;

// ================= INPUTS =================
const suctionPressure = PT_16001;
const suctionFlow = FIC_18002;
const suctionTemp = TT_18003;

// ================= VALVE =================
const valveOpeningRaw = (valveData?.FCV_1601?.opening || 0);

// Clamp 0–100
const valveOpening = Math.max(0, Math.min(100, valveOpeningRaw));

// ================= PUMP STATUS =================
const isPump102AOn = pumpData?.["P-102A"]?.running ?? false;
const isPump102BOn = pumpData?.["P-102B"]?.running ?? false;

const runningPumps = [isPump102AOn, isPump102BOn].filter(Boolean).length;

// ================= INTERLOCK =================
const pumpsAllowed = suctionFlow * (valveData?.FCV_1601?.opening || 0)/100 > 0 && runningPumps > 0;




// ================= TABLES =================
const flowTable = {
  0: 0, 10: 1.01, 20: 1.02, 30: 1.25, 40: 1.5,
  50: 1.7, 60: 1.8, 70: 2.01, 80: 2.3, 90: 2.5, 100: 3
};

const tempTable = {
  0: 5, 10: 1.3, 20: 1.1, 30: 1.08, 40: 1.075,
  50: 1.07, 60: 1.065, 70: 1.06, 80: 1.05, 90: 1.04, 100: 1.03
};

const pressureTable = {
  0: 7, 10: 1.9, 20: 1.6, 30: 1.2, 40: 1.15,
  50: 1.08, 60: 1.06, 70: 1.05, 80: 0.89, 90: 0.8, 100: 1.079
};

// ================= INTERPOLATION =================
const interpolate = (value, table) => {
  const keys = Object.keys(table).map(Number).sort((a, b) => a - b);

  if (table[value] !== undefined) return table[value];

  let lower = 0;
  let upper = 100;

  for (let i = 0; i < keys.length - 1; i++) {
    if (value >= keys[i] && value <= keys[i + 1]) {
      lower = keys[i];
      upper = keys[i + 1];
      break;
    }
  }

  const ratio = (value - lower) / (upper - lower);

  return table[lower] + ratio * (table[upper] - table[lower]);
};

// ================= MULTIPLIERS =================
const flowMultiplier = interpolate(valveOpening, flowTable);
const tempMultiplier = interpolate(valveOpening, tempTable);
const pressureMultiplier = interpolate(valveOpening, pressureTable);

// ================= FLOW =================
// ======================================================
// FIC_16001 FLOW
// ======================================================

const [FINAL_FIC_16001, setFINAL_FIC_16001] =
  useState(0);

useEffect(() => {

  const interval = setInterval(() => {

    if (!pumpsAllowed) {

      setFINAL_FIC_16001(0);

      return;
    }

    // ==========================================
    // BASE FLOW
    // ==========================================

    const baseFlow =
      suctionFlow * flowMultiplier;

    // ==========================================
    // SMALL REALISTIC FLUCTUATION
    // ==========================================

    const fluctuation =
      (Math.random() * 0.6) - 0.3;

    // ==========================================
    // FINAL FLOW
    // ==========================================

    let nextFlow =
      baseFlow + fluctuation;

    // ==========================================
    // SAFETY LIMIT
    // ==========================================

    if (nextFlow < 0)
      nextFlow = 0;

    setFINAL_FIC_16001(
      Number(nextFlow.toFixed(2))
    );

  }, 500);

  return () => clearInterval(interval);

}, [
  pumpsAllowed,
  suctionFlow,
  flowMultiplier
]);


  const FIC_1600 = FINAL_FIC_16001 * (Number(valveData?.FCV_1602?.opening || 0)/100);
  const FIC_16002 = FINAL_FIC_16001 - FIC_1600;




// ================= PRESSURE =================
const [PT_16002, setPT_16002] = useState(() => {
  const saved = localStorage.getItem("PT_16002");
  return saved !== null ? Number(saved) : 0.03;
});

useEffect(() => {
  const interval = setInterval(() => {
    setPT_16002(prev => {

      if (!pumpsAllowed) return 0;

      // EXACT BASE: 1.2 × multiplier
      const target = 1.2 * pressureMultiplier;

      return prev + (target - prev) * 0.15;
    });
  }, 200);

  return () => clearInterval(interval);
}, [pumpsAllowed, pressureMultiplier]);

// ================= TEMPERATURE =================
const [TT_16001, setTT_16001, pumpsRunning] = useState(() => {
  const saved = localStorage.getItem("TT_16001");
  return saved !== null ? Number(saved) : 22;
});

useEffect(() => {
  const interval = setInterval(() => {
    setTT_16001(prev => {

      if (!pumpsAllowed) return 0;

      const target = suctionTemp * tempMultiplier;

      return prev + (target - prev) * 0.15;
    });
  }, 200);

  return () => clearInterval(interval);
}, [pumpsAllowed, suctionTemp, tempMultiplier]);


      // ================= PUSH TO GLOBAL =================
      useEffect(() => {
                    localStorage.setItem("FINAL_FIC_16001", FINAL_FIC_16001);
                  }, [FINAL_FIC_16001]);
      useEffect(() => {
                    localStorage.setItem("PT_16002", PT_16002);
                  }, [PT_16002]);
      useEffect(() => {
                    localStorage.setItem("TT_16001", TT_16001);
                  }, [TT_16001]);
      useEffect(() => {
                    localStorage.setItem("FIC_16001a", FIC_16001a);
                  }, [FIC_16001a]);






      // ================= PROGRAMMING OF HEAT EXCHANGER WATER COOLING =================
const { setTransmitters } = useContext(WellContext);

// ================= VALVES =================
const isXV_1501Open = valves?.XV_1501 === false;
const isXV_1502Open = valves?.XV_1502 === false;

// ================= STATES =================
const [FIC_16003, setFIC_16003] = useState(0);     // Flow
const [PT_16004, setPT_16004] = useState(0.03);   // Pressure
const [TT_16004, setTT_16004] = useState(22);     // ✅ Temperature (UPDATED)

// ================= DYNAMIC LOGIC =================
useEffect(() => {
  const interval = setInterval(() => {

    // ================= NORMAL FLOW =================
    if (isXV_1501Open && isXV_1502Open) {

      setFIC_16003(prev => prev + (50 - prev) * 0.05);     // → 50
      setPT_16004(prev => prev + (1.2 - prev) * 0.05);     // → 1.2
      setTT_16004(prev => prev + (36 - prev) * 0.05);      // → 36

    }

    // ================= BLOCKAGE =================
    else if (!isXV_1501Open && isXV_1502Open) {

      setFIC_16003(prev => prev + (0 - prev) * 0.08);      // → 0
      setPT_16004(prev => prev + (8 - prev) * 0.06);       // → 8
      setTT_16004(prev => prev + (65 - prev) * 0.05);      // → 65

    }

    // ================= FULL SHUTDOWN =================
    else {

      setFIC_16003(prev => prev + (0 - prev) * 0.08);      // → 0
      setPT_16004(prev => prev + (0.03 - prev) * 0.05);    // → 0.03
      setTT_16004(prev => prev + (22 - prev) * 0.05);      // → 22

    }

  }, 200);

  return () => clearInterval(interval);

}, [!isXV_1501Open, !isXV_1502Open]);

// ================= PUSH TO GLOBAL =================
useEffect(() => {
  if (typeof setTransmitters !== "function") return;

  setTransmitters(prev => ({
    ...prev,
    FIC_16003: Number(FIC_16003.toFixed(2)),
    PT_16004: Number(PT_16004.toFixed(2)),
    TT_16004: Number(TT_16004.toFixed(2)), // ✅ UPDATED
  }));

}, [FIC_16003, PT_16004, TT_16004]);





      // ================= PROGRAMMING OF HEAT EXCHANGER WATER DISCHARGE =================


// ================= INPUTS =================
const waterInletFlow = Number(transmitters?.FIC_16003 ?? 0);
const waterInletTemp = Number(transmitters?.TT_16004 ?? 22);

// ================= FOULING FACTOR =================
const [foulingFactor, setFoulingFactor] = useState(1);

// ================= STATES =================
const [FIC_16005, setFIC_16005] = useState(0);
const [TT_16005, setTT_16005] = useState(waterInletTemp);
const [PT_16005, setPT_16005] = useState(0.03);

// ================= DYNAMIC LOGIC =================
useEffect(() => {
  const interval = setInterval(() => {

    // ================= NORMAL OPERATION =================
    if (isXV_1501Open && isXV_1502Open) {

      // Flow (with fouling + exchanger loss)
      const flowTarget = waterInletFlow * 0.989 * foulingFactor;

      // Temperature rise (22 → ~36 baseline)
      const tempRise = 14 * foulingFactor;
      const tempTarget = waterInletTemp + tempRise;

      // Pressure buildup
      const pressureTarget = 1.2 * foulingFactor;

      setFIC_16005(prev => prev + (flowTarget - prev) * 0.05);
      setTT_16005(prev => prev + (tempTarget - prev) * 0.05);
      setPT_16005(prev => prev + (pressureTarget - prev) * 0.05);
    }

    // ================= ANY VALVE CLOSED =================
    else {

      setFIC_16005(prev => prev + (0 - prev) * 0.08);
      setTT_16005(prev => prev + (22 - prev) * 0.05);
      setPT_16005(prev => prev + (0.03 - prev) * 0.05);
    }

  }, 200);

  return () => clearInterval(interval);

}, [isXV_1501Open, isXV_1502Open, waterInletFlow, waterInletTemp, foulingFactor]);

// ================= PUSH TO GLOBAL =================
useEffect(() => {
  if (typeof setTransmitters !== "function") return;

  setTransmitters(prev => ({
    ...prev,
    FIC_16005: Number(FIC_16005.toFixed(2)),
    TT_16005: Number(TT_16005.toFixed(2)),
    PT_16005: Number(PT_16005.toFixed(2)),
  }));

}, [FIC_16005, TT_16005, PT_16005]);







// ================= CONSTANTS =================
const WATER_MIN = 22;
const WATER_MAX = 30;

const CRUDE_MIN = 38; // lowest allowed crude temp

// ================= PRESSURE =================
const [TT_16003, setTT_16003] = useState(() => {
  const saved = localStorage.getItem("TT_16003");
  return saved !== null ? Number(saved) : 22;
});

// ================= MAPPING LOGIC =================
useEffect(() => {
  const interval = setInterval(() => {

    // Normalize water temperature (0 → 1)
    let normalized =
      (TT_16005 - WATER_MIN) / (WATER_MAX - WATER_MIN);

    normalized = Math.max(0, Math.min(normalized, 1)); // clamp

    // Map to crude cooling
    const crudeTarget =
      TT_16001 - normalized * (TT_16001 - CRUDE_MIN);

    // Smooth transition (dynamic)
    setTT_16003(prev =>
      prev + (crudeTarget - prev) * 0.07
    );

  }, 200);

  return () => clearInterval(interval);

}, [TT_16001, TT_16005]);

// ================= PUSH =================
useEffect(() => {
  if (typeof setTransmitters !== "function") return;

  setTransmitters(prev => ({
    ...prev,
    TT_16003: Number(TT_16003.toFixed(2)),
  }));

}, [TT_16003]);








// ================= SPLIT FLOW OF FIC_16002 INTO TWO BRANCHES =================

// MAIN INLET FLOW FROM FIC_16002
const inletFlow_FIC16002 =FIC_16002;

// ================= SHUTDOWN VALVES STATUS =================
const isXV_1504Open = valves?.XV_1504 === false;
const isXV_1505Open = valves?.XV_1505 === false;
const isXV_1503Open = valves?.XV_1503 === false;


// ================= FLOW SPLIT =================
let FIC_16006 = 0;
let FIC_16007 = 0;

// BOTH OPEN = 50 / 50 SPLIT
if (isXV_1504Open && isXV_1505Open) {
  FIC_16006 = inletFlow_FIC16002 / 2;
  FIC_16007 = inletFlow_FIC16002 / 2;
}

// ONLY LINE 1 OPEN
else if (isXV_1504Open && !isXV_1505Open) {
  FIC_16006 = inletFlow_FIC16002;
  FIC_16007 = 0;
}

// ONLY LINE 2 OPEN
else if (!isXV_1504Open && isXV_1505Open) {
  FIC_16006 = 0;
  FIC_16007 = inletFlow_FIC16002;
}

// BOTH CLOSED = ZERO FLOW
else {
  FIC_16006 = 0;
  FIC_16007 = 0;
}

// ================= ROUNDING =================
FIC_16006 = Number(FIC_16006.toFixed(2));
FIC_16007 = Number(FIC_16007.toFixed(2));

// ================= SAVE TO LOCAL STORAGE =================
useEffect(() => {
  localStorage.setItem("FIC_16006", FIC_16006);
}, [FIC_16006]);

useEffect(() => {
  localStorage.setItem("FIC_16007", FIC_16007);
}, [FIC_16007]);

// ================= PUSH TO GLOBAL TRANSMITTERS =================
useEffect(() => {
  if (typeof setTransmitters !== "function") return;

  setTransmitters((prev) => ({
    ...prev,
    FIC_16006,
    FIC_16007,
  }));
}, [FIC_16006, FIC_16007]);


// ================= FIQ_16006 TOTALIZER =================

const [FIQ_16006, setFIQ_16006] = useState(() => {
  return Number(localStorage.getItem("FIQ_16006")) || 0;
});


// ================= ACCUMULATE EVERY SECOND =================

useEffect(() => {
  const timer = setInterval(() => {
    if (
      isXV_1503Open &&
      (isXV_1504Open || isXV_1505Open)
    ) {
      const totalFlow = FIC_16006 + FIC_16007;

      // convert flow to increment
      const increment = totalFlow / 60 / 24;

      setFIQ_16006((prev) => prev + increment);
    }
  }, 1000);

  return () => clearInterval(timer);
}, [
  isXV_1503Open,
  isXV_1504Open,
  isXV_1505Open,
  FIC_16006,
  FIC_16007
]);

// ================= SAVE =================
useEffect(() => {
  localStorage.setItem("FIQ_16006", FIQ_16006.toFixed(2));

  if (typeof setTransmitters === "function") {
    setTransmitters((prev) => ({
      ...prev,
      FIQ_16006: Number(FIQ_16006.toFixed(2)),
    }));
  }
}, [FIQ_16006]);

// ================= RESET BUTTON FUNCTION =================
const resetFIQ16006 = () => {
  setFIQ_16006(0);
  localStorage.setItem("FIQ_16006", "0");
};



// ================= METERING UNIT TEMP / PRESSURE SPLIT =================
// Incoming:
// TT_16003
// PT_16002

const inletTemp = TT_16003;
const inletPressure = PT_16002;


// ================= STATES =================
const [TT_16006, setTT_16006] = useState(22);
const [PT_16006, setPT_16006] = useState(0.03);

const [TT_16007, setTT_16007] = useState(22);
const [PT_16007, setPT_16007] = useState(0.03);

// ================= USER MAX BLOCKED VALUES =================
const MAX_TEMP_LINE1 = 95;
const MAX_PRESS_LINE1 = 8.5;

const MAX_TEMP_LINE2 = 95;
const MAX_PRESS_LINE2 = 8.5;

// ================= MAIN LOGIC =================
useEffect(() => {
  const timer = setInterval(() => {

    // ================= LINE 1 =================
    if (isXV_1504Open) {

      // Normal flowing condition
      if (isXV_1503Open) {
        setTT_16006(prev => prev + (inletTemp - prev) * 0.15);
        setPT_16006(prev => prev + (inletPressure - prev) * 0.15);
      }

      // Deadhead / blocked condition
      else {
        setTT_16006(prev => Math.min(prev + 0.35, MAX_TEMP_LINE1));
        setPT_16006(prev => Math.min(prev + 0.08, MAX_PRESS_LINE1));
      }

    } else {
      // valve closed cool down / depressure
      setTT_16006(prev => Math.max(prev - 0.25, 22));
      setPT_16006(prev => Math.max(prev - 0.03, 0.03));
    }

    // ================= LINE 2 =================
    if (isXV_1505Open) {

      // Normal flowing condition
      if (isXV_1503Open) {
        setTT_16007(prev => prev + (inletTemp - prev) * 0.15);
        setPT_16007(prev => prev + (inletPressure - prev) * 0.15);
      }

      // Deadhead / blocked condition
      else {
        setTT_16007(prev => Math.min(prev + 0.35, MAX_TEMP_LINE2));
        setPT_16007(prev => Math.min(prev + 0.08, MAX_PRESS_LINE2));
      }

    } else {
      // valve closed cool down / depressure
      setTT_16007(prev => Math.max(prev - 0.25, 22));
      setPT_16007(prev => Math.max(prev - 0.03, 0.03));
    }

    // ================= ALL CLOSED =================
    if (!isXV_1503Open && !isXV_1504Open && !isXV_1505Open) {
      setTT_16006(prev => Math.max(prev - 0.25, 22));
      setPT_16006(prev => Math.max(prev - 0.03, 0.03));

      setTT_16007(prev => Math.max(prev - 0.25, 22));
      setPT_16007(prev => Math.max(prev - 0.03, 0.03));
    }

  }, 1000);

  return () => clearInterval(timer);

}, [
  inletTemp,
  inletPressure,
  isXV_1503Open,
  isXV_1504Open,
  isXV_1505Open
]);

// ================= SAVE / PUSH =================
useEffect(() => {
  localStorage.setItem("TT_16006", TT_16006);
  localStorage.setItem("PT_16006", PT_16006);
  localStorage.setItem("TT_16007", TT_16007);
  localStorage.setItem("PT_16007", PT_16007);

  if (typeof setTransmitters === "function") {
    setTransmitters(prev => ({
      ...prev,
      TT_16006: Number(TT_16006.toFixed(2)),
      PT_16006: Number(PT_16006.toFixed(2)),
      TT_16007: Number(TT_16007.toFixed(2)),
      PT_16007: Number(PT_16007.toFixed(2)),
    }));
  }

}, [TT_16006, PT_16006, TT_16007, PT_16007]);




  return (
    <div className="CrudeExport-container">
      {/* TITLE */}
      <h2 style={{
        position: "absolute",
        top: "2px",
        left: "196px",
        color: "white",
        background: "rgb(29, 5, 247)",
        padding: "2px 320px"
      }}>
        CRUDE METERING AND EXPORT
      </h2>

      {/* =================SHUTDOWN VALVES ================= */}

      
      {/* XV-1501 */}
      <Valve
        className="XV-1501"
        tag="XV_1501"
        x={693}
        y={340}
        isClosed={valves.XV_1501}
        toggle={toggleValve}
      />

      {/* XV-1502 */}
      <Valve
        className="XV-1502"
        tag="XV_1502"
        x={1162}
        y={90}
        isClosed={valves.XV_1502}
        toggle={toggleValve}
        r={0}
      />

      
      {/* XV-1503 */}
      <Valve
        className="XV-1503"
        tag="XV_1503"
        x={1128}
        y={547}
        isClosed={valves.XV_1503}
        toggle={toggleValve}
        r={0}
      />

      
      {/* XV-1504 */}
      <Valve
        className="XV-1504"
        tag="XV_1504"
        x={590}
        y={479}
        isClosed={valves.XV_1504}
        toggle={toggleValve}
        r={0}
      />

      
      {/* XV-1505 */}
      <Valve
        className="XV-1505"
        tag="XV_1505"
        x={603}
        y={597}
        isClosed={valves.XV_1505}
        toggle={toggleValve}
        r={0}
      />


      
        {/* ================= CONTROL VALVES SVG ================= */}
        

         {/* FCV-1601 */}
        <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-1601"
          style={{ position: "absolute", left: 316, top: 253, transform: "rotate(270deg)", transformOrigin: "center"}}  onClick={() => openPanel("FCV_1601")}>
          
          <defs>
            <linearGradient id="metal_1601">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>

          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_1601)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_1601)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>
        

         {/* FCV-1602 */}
        <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-1602"
          style={{ position: "absolute", left: 197, top: 177}}  onClick={() => openPanel("FCV_1602")}>
          
          <defs>
            <linearGradient id="metal_1602">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>

          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_1602)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_1602)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>


          
        
        {/* ================= CONTROL VALVE FACEPLATES ================= */}
          {openPanels.map((tag, index) => (
            <ControlValveControlPanel
              key={tag}
              tag={tag}
              data={valveData?.[tag] ?? DEFAULT_VALVES?.[tag]}
              update={updateValveData}
              close={() => closePanel(tag)}
              defaultPosition={{
                x: 300 + index * 40,
                y: 150 + index * 40
              }}
            />
          ))}

          
          {/* ================= PUMPS CONTROL VALVE FACEPLATES ================= */}
          {openPumpPanels.map((tag, index) => (
            <PumpFaceplate
              key={tag}
              tag={tag}
              close={() => closePumpPanel(tag)}
              defaultPosition={{
                x: 300 + index * 40,
                y: 150 + index * 40
              }}
            />
          ))}


          {/* ================= CONTROL VALVE OUTPUTS ================= */}

      <ValveOutput
        value={Number(valveData?.FCV_1601?.opening || 0)}
        x={373}
        y={268}
      />

      <ValveOutput
        value={Number(valveData?.FCV_1602?.opening || 0)}
        x={224}
        y={218}
      />

      <Transmitter4
      value={FIC_16001a}
      x={120}
      y={397}
      c="transparent"
    />

    <Transmitter
        tag="PT-16001"
        value={[PT_16001]}
        x={120}
        y={447}
        unit="MPa"
        max={2}
        HH={1.8}
        H={1.6}
        L={0.04}
        LL={0.01}
        c="lime"
        description="PRESSURE OF CRUDE AT THE SUCTION OF CRUDE EXPORT PUMPS"
      />
 

    <Transmitter
        tag="FIC-16001"
        value={[FINAL_FIC_16001]}
        x={383}
        y={328}
        unit="BPM"
        max={200}
        HH={180}
        H={150}
        L={5}
        LL={3}
        c="lime"
        description="FLOWRATE OF CRUDE AT THE DISCHARGE OF CRUDE EXPORT PUMPS"
      />


    <Transmitter
        tag="FIC-16002"
        value={[FIC_16002]}
        x={388}
        y={82}
        unit="BPM"
        max={200}
        HH={180}
        H={150}
        L={5}
        LL={3}
        c="lime"
        description="FLOWRATE OF CRUDE AT THE SUCTION OF CRUDE EXPORT HEAT EXCHANGER"
      />


    <Transmitter
        tag="FIC-1600"
        value={[FIC_1600]}
        x={130}
        y={166}
        unit="BPM"
        max={200}
        HH={180}
        H={150}
        L={5}
        LL={3}
        c="lime"
        description="FLOWRATE OF UNQUALIFIED CRUDE RETURN TO 3RD STAGE SEPARATOR"
      />


    <Transmitter
        tag="PT-16002"
        value={[PT_16002]}
        x={290}
        y={328}
        unit="MPa"
        max={2}
        HH={1.8}
        H={1.6}
        L={0.04}
        LL={0.01}
        c="lime"
        description="PRESSURE OF CRUDE AT THE DISCHARGE OF CRUDE EXPORT PUMPS"
      />


    <Transmitter
        tag="TT-16001"
        value={[TT_16001]}
        x={300}
        y={166}
        unit="°C"
        max={40}
        HH={38}
        H={37}
        L={20}
        LL={10}
        c="lime"
        description="TEMPERATURE OF UNQUALIFIED CRUDE RETURN TO 3RD STAGE SEPARATOR"
      />

    
      <Transmitter4
      value={suctionFlow}
      x={300}
      y={461}
      c="transparent"
    />
   
    <Transmitter
        tag="TT-16004"
        value={[TT_16004]}
        x={1070}
        y={82}
        unit="°C"
        max={40}
        HH={38}
        H={37}
        L={20}
        LL={10}
        c="lime"
        description="TEMPERATURE OF WATER FROM FRESH WATER SUPPLY TO CRUDE EXPORT COOLER"
      />
 
    <Transmitter
        tag="PT_16004"
        value={[PT_16004]}
        x={975}
        y={82}
        unit="MPa"
        max={2}
        HH={1.8}
        H={1.6}
        L={0.04}
        LL={0.01}
        c="lime"
        description="PRESSURE OF WATER FROM FRESH WATER SUPPLY TO CRUDE EXPORT COOLER FOR HEAT EXCHANGING"
      />
  
    <Transmitter
        tag="FIC-16003"
        value={[FIC_16003]}
        x={880}
        y={82}
        unit="LPM"
        max={50}
        HH={45}
        H={40}
        L={5}
        LL={3}
        c="lime"
        description="FLOWRATE OF WATER FROM FRESH WATER SUPPLY TO CRUDE EXPORT COOLER FOR HEAT EXCHANGING"
      />
   
    <Transmitter
        tag="TT_16005"
        value={[TT_16005]}
        x={1010}
        y={329}
        unit="°C"
        max={40}
        HH={38}
        H={37}
        L={20}
        LL={10}
        c="lime"
        description="TEMPERATURE OF WATER FROM CRUDE EXPORT COOLER TO FRESH WATER RETURN LINE"
      />


    <Transmitter
        tag="PT-16005"
        value={[PT_16005]}
        x={925}
        y={329}
        unit="MPa"
        max={2}
        HH={1.8}
        H={1.6}
        L={0.04}
        LL={0.01}
        c="lime"
        description="PRESSURE OF WATER FROM CRUDE EXPORT COOLER TO FRESH WATER RETURN LINE"
      />


    <Transmitter
        tag="FIC-16005"
        value={[FIC_16005]}
        x={829}
        y={329}
        unit="LPM"
        max={55}
        HH={48}
        H={45}
        L={5}
        LL={3}
        c="lime"
        description="FLOWRATE OF WATER FROM CRUDE EXPORT COOLER TO FRESH WATER RETURN LINE"
      />

    <Transmitter
        tag="TT-16003"
        value={[TT_16003]}
        x={488}
        y={328}
        unit="°C"
        max={70}
        HH={68}
        H={57}
        L={20}
        LL={10}
        c="lime"
        description="TEMPERATURE OF CRUDE AT THE DISCHARGE OF OIL COOLER TO METERING STATION"
      />




    <Transmitter
        tag="FIC-16006"
        value={[FIC_16006]}
        x={674}
        y={465}
        unit="BPM"
        max={200}
        HH={190}
        H={175}
        L={5}
        LL={3}
        c="lime"
        description="FLOWRATE OF CRUDE ON METERING SKID LINE ONE (1) TO EXPORT PIPELINE"
      />


    <Transmitter
        tag="TT-16006"
        value={[TT_16006]}
        x={860}
        y={465}
        unit="°C"
        max={70}
        HH={68}
        H={57}
        L={20}
        LL={10}
        c="lime"
        description="TEMPERATURE OF CRUDE ON METERING SKID LINE ONE (1) TO EXPORT PIPELINE"
      />

    <Transmitter
        tag="PT-16006"
        value={[PT_16006]}
        x={768}
        y={465}
        unit="MPa"
        max={2}
        HH={1.8}
        H={1.6}
        L={0.4}
        LL={0.1}
        c="lime"
        description="PRESSURE OF CRUDE ON METERING SKID LINE ONE (1) TO EXPORT PIPELINE"
      />

     

    <Transmitter
        tag="FIC-16007"
        value={[FIC_16007]}
        x={674}
        y={575}
        unit="BPM"
        max={200}
        HH={190}
        H={175}
        L={5}
        LL={3}
        c="lime"
        description="FLOWRATE OF CRUDE ON METERING SKID LINE ONE (2) TO EXPORT PIPELINE"
      />

    <Transmitter
        tag="TT-16007"
        value={[TT_16007]}
        x={858}
        y={575}
        unit="°C"
        max={70}
        HH={68}
        H={57}
        L={20}
        LL={10}
        c="lime"
        description="TEMPERATURE OF CRUDE ON METERING SKID LINE ONE (2) TO EXPORT PIPELINE"
      />
   
    <Transmitter
        tag="PT-16007"
        value={[PT_16007]}
        x={764}
        y={575}
        unit="MPa"
        max={2}
        HH={1.8}
        H={1.5}
        L={0.4}
        LL={0.1}
        c="lime"
        description="PRESSURE OF CRUDE ON METERING SKID LINE ONE (2) TO EXPORT PIPELINE"
      />

        
    <Transmitter
      tag="FIQ-16006"
      value={FIQ_16006}
      x={1025}
      y={527}
      unit="BPD"
      max={420000}
      HH={400000}
      H={300000}
      L={20000}
      LL={10000}
      c="lime"
      description="TOTALIZE FOR CRUDE EXPERT PIPELINE FROM CRUDE METERING STATION"
    />



     <Pump
      tag="P-102A"
      x={266}
      y={393}
      rpm={1800}
      bladeCount={pumpData?.["P-102A"]?.bladeCount || 5}
      size={pumpData?.["P-102A"]?.size || 37}
      onClick={openPumpPanel}
    />

    <Pump
      tag="P-102B"
      x={258}
      y={515}
      rpm={1800}
      bladeCount={pumpData?.["P-102B"]?.bladeCount || 3}
      size={pumpData?.["P-102B"]?.size || 37}
      onClick={openPumpPanel}
    />


    <input
      type="number"
      step="0.1"
      value={foulingFactor}
      onChange={(e) => setFoulingFactor(Number(e.target.value) || 1)}
      className="egt-input"
      style={{
          position: "absolute",
          left: "570px",
          top: "140px",
          background: "transparent",
          color: "grey",
          border: "1px solid transparent",
          outline: "none"
        }}
    />

        
    <button
      onClick={resetFIQ16006}
      style={{
        position: "absolute",
        left: "1026px",
        top: "497px",
        padding: "0px 6px",
        fontSize: "12px",
        cursor: "pointer",
        zIndex: 10
      }}
    >
      Reset FIQ
    </button>





    </div>
  );
}

export default CrudeExport;